import * as Constants from './constants'

const initialState = {
  list: [],
  item: {},
  type: Constants.TRAHANG_LIST_INITING,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
  callback: function () { },
}

const reducer = function nganhHangReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.TRAHANG_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.TRAHANG_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        item: action.data || {},
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.TRAHANG_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.TRAHANG_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
      }

    case Constants.TRAHANG_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        item: action.payload.data,
        type: action.type,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }]
      }

    case Constants.TRAHANG_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/TraHang/reducer.js